import React, { useState, useEffect } from "react";
import { SubtitleText } from "raffle-house-uikit";
import ReactHtmlParse from "html-react-parser";
import TicketSelectorTabPanel from "./TicketSelectorTabPanel/TicketSelectorTabPanel";
import TicketSelectorTabControls from "./TicketSelectorTabControls/TicketSelectorTabControls";
import TicketList from "../TicketList/TicketList";
import SubscriptionList from "../SubscriptionList/SubscritpionList";

import "./styles.css";

export const ticketSelectorTabs = [
  {
    id: "single",
    title: "Single purchase",
  },
  {
    id: "subscribe",
    title: "Subscribe & save",
  },
];

const TicketSelector = (props) => {
  const {
    prizeId,
    isExpired,
    subscriptionModels,
    subtitle,
    theme = "light",
    reference,
    bonusDraw,
  } = props;

  const [activeTabId, setActiveTabId] = useState("subscribe");
  const [sortedSubscriptionModels, setSortedSubscriptionModels] = useState([]);
  const handleChangeActiveTab = (id) => setActiveTabId(id);

  useEffect(() => {
    sortSubscriptionModels();
  }, [subscriptionModels]);

  const sortSubscriptionModels = () => {
    if (subscriptionModels && subscriptionModels.length) {
      const sortedSubscr = subscriptionModels.sort(
        (a, b) => b.totalCost - a.totalCost,
      );
      setSortedSubscriptionModels(sortedSubscr);
    }
  };

  return (
    <div className="ticket-selector" ref={reference}>
      <SubtitleText
        isCentered
        color={`${theme === "light" ? "color-1" : "color-5"}`}
      >
        {subtitle ? ReactHtmlParse(subtitle) : null}
      </SubtitleText>
      <TicketSelectorTabControls
        tabs={ticketSelectorTabs}
        activeTabId={activeTabId}
        onChangeActiveTab={handleChangeActiveTab}
      />
      <TicketSelectorTabPanel id="single" activeTabId={activeTabId}>
        <TicketList
          prizeId={prizeId}
          raffles={props.raffles}
          isExpired={isExpired}
          currentRaffle={props.currentRaffle}
          theme="light"
          bonusDraw={bonusDraw}
        />
      </TicketSelectorTabPanel>
      <TicketSelectorTabPanel id="subscribe" activeTabId={activeTabId}>
        <SubscriptionList
          prizeId={prizeId}
          subscriptionModels={sortedSubscriptionModels}
          raffles={props.raffles}
          isExpired={isExpired}
          currentRaffle={props.currentRaffle}
          theme="light"
        />
      </TicketSelectorTabPanel>
    </div>
  );
};

export default TicketSelector;
